import { pathOr } from 'ramda';

import events from 'app/analytics';
import { experimentEventProperties } from 'app/features/deltaConfig/selectors';
import noop from 'app/libs/noop';

const analytics =
  ({ getState }) =>
  next =>
  action => {
    next(action);

    const event = events[action.type]?.(getState, action);

    if (event) {
      const { name, type, properties } = event;
      const experimentEventProps = experimentEventProperties(getState());
      const analyticsFunction = pathOr(noop, ['analytics', type], window);

      analyticsFunction(name, { ...properties, ...experimentEventProps });
    }
  };

export default analytics;
